"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnchorProps = void 0;
const classes_1 = require("../constants/classes");
const cx_1 = require("../utils/cx");
const _useSimulatedButton_1 = require("./_useSimulatedButton");
function useAnchorProps({ ["aria-busy"]: ariaBusy, ["aria-disabled"]: ariaDisabled, analyticsCallback, className, disabled, download, href, hrefLang, loading, media, onClick, onKeyDown, onKeyUp, ping, referrerPolicy, rel, role, tabIndex, target, type, ...restProps }) {
    const isBusy = loading ? loading : Boolean(ariaBusy);
    const isDisabled = disabled ? disabled : Boolean(ariaDisabled);
    const isBusyOrDisabled = isBusy || isDisabled;
    const submit = type === "submit";
    const isButton = submit || !!onClick;
    const tabIndexInteractive = isBusyOrDisabled ? -1 : tabIndex;
    const _className = [isBusy && classes_1.CLASSES.IS_LOADING, disabled && classes_1.CLASSES.IS_DISABLED, className];
    const simulatedButton = (0, _useSimulatedButton_1._useSimulatedButton)({
        analyticsCallback,
        isClickable: !isBusyOrDisabled || isButton,
        isHyperlink: !isBusyOrDisabled || !!href,
        onClick,
        onKeyDown,
        onKeyUp,
        submit,
    });
    if (href) {
        return {
            "aria-busy": isBusy,
            "aria-disabled": isDisabled,
            className: (0, cx_1.cx)(classes_1.CLASSES.IS_HOVERABLE, ..._className),
            download,
            href,
            hrefLang,
            media,
            onClick: simulatedButton.onClick,
            onKeyDown: simulatedButton.onKeyDown,
            onKeyUp: simulatedButton.onKeyUp,
            ping,
            referrerPolicy,
            rel: target === "_blank" ? (rel ? `noopener noreferrer ${rel}` : "noopener noreferrer") : rel,
            role: role || (isButton ? "button" : undefined),
            tabIndex: tabIndexInteractive,
            target,
            ...restProps,
        };
    }
    if (isButton) {
        return {
            "aria-busy": isBusy,
            "aria-disabled": isDisabled,
            className: (0, cx_1.cx)(classes_1.CLASSES.IS_HOVERABLE, ..._className),
            onClick: simulatedButton.onClick,
            onKeyDown: simulatedButton.onKeyDown,
            onKeyUp: simulatedButton.onKeyUp,
            role: role || "button",
            tabIndex: tabIndexInteractive !== null && tabIndexInteractive !== void 0 ? tabIndexInteractive : 0,
            ...restProps,
        };
    }
    return {
        className: (0, cx_1.cx)(..._className),
        role: role || "none",
        tabIndex,
        ...restProps,
    };
}
exports.useAnchorProps = useAnchorProps;
